export default "__VITE_ASSET__CfqzA24T__"